import { render, staticRenderFns } from "./StaffChat.vue?vue&type=template&id=449a20dc&scoped=true&"
import script from "./StaffChat.vue?vue&type=script&lang=js&"
export * from "./StaffChat.vue?vue&type=script&lang=js&"
import style0 from "@/components/style/side-box.scss?vue&type=style&index=0&id=449a20dc&scoped=true&lang=scss&"
import style1 from "@/components/style/staff.scss?vue&type=style&index=1&id=449a20dc&scoped=true&lang=scss&"
import style2 from "@/components/style/staff-chat.scss?vue&type=style&index=2&id=449a20dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a20dc",
  null
  
)

export default component.exports